import { Routes, Route } from 'react-router-dom';
import { Overview } from './about/Overview';
import { Mission } from './about/Mission';
import { Team } from './about/Team';
import { Technology } from './about/Technology';
import { Facilities } from './about/Facilities';

export function About() {
  return (
    <Routes>
      <Route index element={<Overview />} />
      <Route path="mission" element={<Mission />} />
      <Route path="team" element={<Team />} />
      <Route path="technology" element={<Technology />} />
      <Route path="facilities" element={<Facilities />} />
    </Routes>
  );
}